import axios from 'axios';
import FAQCategory from '../models/FAQCategory';
import FAQCategoryMapper from '../mappers/FAQCategory.mapper';
import FAQArticleMapper from '../mappers/FAQArticle.mapper';
import FAQArticle from '../models/FAQArticle';
import FAQSearchResult from '../models/FAQSearchResult';
import FAQSearchResultMapper from '../mappers/FAQSearchResultMapper';

export default class FAQService {
    public async getFAQCategories(overviewID: number, language: string, persona: string): Promise<FAQCategory[]> {
        let api = axios.create({
            baseURL: ''
        })
        const data : any = await api.get('/FAQ/Categories/' + overviewID + '?language=' + language + '&personaID=' + persona);

        const faqCategories : FAQCategory[] = data.data.map((cat: any) => { return new FAQCategoryMapper().map(cat)} );

        return faqCategories;
    }

    public async searchFAQArticles(keywords: string, persona: string, language: string, numberOfSearchResults : number) : Promise<FAQSearchResult> {
        let api = axios.create({
            baseURL: ''
        })
        const data : any = await api.get('/FAQ/Search?keywords=' + keywords + '&personaID=' + persona + '&language=' + language + '&numberOfSearchResults=' + numberOfSearchResults);

        const result: FAQSearchResult = FAQSearchResultMapper.map(data.data);

        return result;
    }
}